(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6618],{

/***/ 15438:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var keyExistsOn = function keyExistsOn(o, k) {
  return k.split(".").reduce(function (a, c) {
    return a.hasOwnProperty(c) ? a[c] || 1 : false;
  }, Object.assign({}, o)) === false ? false : true;
};

/* harmony default export */ __webpack_exports__["Z"] = (keyExistsOn);

/***/ }),

/***/ 68752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var IncludedFee = function IncludedFee(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: data.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "row mb-4 justify-between last:mb-0 lg:mb-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "col-12 self-center lg:col-6",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "h2",
            className: "bbc-title mb-4 text-center font-semibold text-bbc-brand-800 lg:mb-8 lg:text-left",
            text: item.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
            className: "mx-4 mb-6 list-disc leading-bbc-26 lg:mx-0 lg:mb-0 ",
            children: item.contents.map(function (content, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
                className: "  relative mb-2 list-none pl-5  text-bbc-gray before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-[5px] before:w-[5px] before:rounded-full before:bg-bbc-gray before:content-['']",
                children: content
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "col-12 text-center lg:col-6 ".concat(item.positionImage === "left" ? "lg:order-first lg:text-left" : "order-last lg:text-right"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, item.img))
        })]
      }, index);
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (IncludedFee);
IncludedFee.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {})
};

/***/ }),

/***/ 10965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83719);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var checkLocale = function checkLocale(path) {
  return path.includes("/offshore") ? path.split("/offshore")[1] : path.includes("/hk") ? path.split("/hk")[1] : path.includes("/sg") ? path.split("/sg")[1] : path.includes("/vn") && path.split("/vn")[1];
};

var Component = function Component(_ref) {
  var data = _ref.data;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(checkLocale(router.pathname)),
      activeIndex = _useState[0];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "shadow-bbc relative  hidden w-fit rounded-xl bg-white text-center lg:inline-block",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("ul", {
        className: "whitespace-nowrap py-3 px-5",
        children: Array.isArray(data) && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("li", {
            className: "inline-block  ".concat(index < data.length - 1 ? "border-r-2" : ""),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              as: "a",
              variant: "ghost",
              href: item.uri,
              useRouter: true,
              btnTextColor: "".concat(activeIndex === item.uri ? "" : "text-bbc-neutral-700 hover:text-bbc-brand-600"),
              othersClass: "".concat(activeIndex === item.uri ? "" : "inline-block font-normal"),
              children: item.title
            })
          }, index);
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Dropdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      className: "dropdown-default m-auto block lg:hidden",
      data: data,
      activeIndex: data.length > 0 && data.find(function (item) {
        return activeIndex === item.uri;
      }).title
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);
Component.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {})
};

/***/ }),

/***/ 32144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56727);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98989);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);







function TabListNew(_ref) {
  var data = _ref.data,
      activeTab = _ref.activeTab,
      tabLinks = _ref.tabLinks,
      tabListClass = _ref.tabListClass,
      tabClass = _ref.tabClass,
      children = _ref.children,
      _onChange = _ref.onChange;
  var tabListStyle = ["rounded-full", tabListClass.display || "flex justify-start lg:justify-center", tabListClass.length || " w-fit mx-auto", tabListClass.background || "bg-transparent", tabListClass.padding || "p-0", tabListClass.border || "border md:border border-bbc-neutral-600", tabListClass.othersClass].join(" ");
  var tabStyle = ["relative select-none rounded-full cursor-pointer border transition-all duration-100 ring-0 outline-none focus:ring-0 focus:outline-0 focus:outline-none text-center", tabClass.width || "w-fit", tabClass.textSize || "text-sm leading-6", tabClass.textFontWeight || "font-semibold", tabClass.padding || "py-3 px-6", tabClass.margin || "", tabClass.othersClass].join(" ");
  /* Handle Event */

  var handleOnClickTabLink = function handleOnClickTabLink(e) {
    e.preventDefault();
    window.history.pushState(null, null, e.target.getAttribute("data-go"));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "w-full",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.Group */ .OK.Group, {
      defaultIndex: activeTab || 0,
      onChange: function onChange() {
        return _onChange && _onChange();
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.List */ .OK.List, {
        className: (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabListStyle),
        children: Object.keys(data).length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .OK, {
            className: function className(_ref2) {
              var selected = _ref2.selected;
              return (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabStyle, selected ? "".concat(tabClass.tabColorActive || "border-bbc-brand-500 text-bbc-brand-500") : " ".concat(tabClass.tabColor || "border-transparent bg-transparent text-bbc-neutral-600 hover:text-bbc-brand-500", " "));
            },
            as: "div",
            children: [item.title || item, Array.isArray(tabLinks) && (tabLinks === null || tabLinks === void 0 ? void 0 : tabLinks.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
              "data-go": "#".concat(tabLinks[index]),
              onClick: handleOnClickTabLink,
              className: "absolute inset-0 h-full w-full"
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})]
          }, item.id || item);
        })
      }), children]
    })
  });
}

TabListNew.defaultProps = {
  tabListClass: {},
  tabClass: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (TabListNew);

/***/ }),

/***/ 3771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ noteTraditional; }
/* harmony export */ });
var noteTraditional = function noteTraditional(data, hideInitialNote) {
  var dataTraditional = data;
  var getSingapore = dataTraditional === null || dataTraditional === void 0 ? void 0 : dataTraditional.find(function (item) {
    return item.id === 191;
  });
  var findSpecialBank = getSingapore === null || getSingapore === void 0 ? void 0 : getSingapore.banks.find(function (item) {
    return item.name === "OCBC Bank*";
  });
  var note = "**Initial deposit is often blocked in the offshore bank account; if so, this amount is often small.<br/> However, banks in Hong Kong and Singapore do not freeze this amount, so you can use it freely. But you will be charged an additional fee for not maintaining your account above min balance.";

  if (getSingapore && findSpecialBank) {
    if (hideInitialNote) {
      note = "* Remote opening applies for Singapore-incorporated companies only.";
    } else {
      note += "<br/>* Remote opening applies for Singapore-incorporated companies only.";
    }
  } else {
    if (hideInitialNote) {
      note = null;
    }
  }

  return note;
};

/***/ }),

/***/ 80651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var OnlineBankingTool = function OnlineBankingTool(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "row justify-center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "row col-12 rounded-3xl bg-bbc-gradient-9 py-6 lg:col-10 lg:py-0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
            className: "col-12 order-1 self-center pr-0 lg:col-5 lg:order-0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              text: data.title,
              as: "h5",
              className: "mb-6 pr-0 text-bbc-30px font-semibold capitalize text-bbc-main"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
              className: "mb-6 text-base font-normal text-white",
              children: data.description
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: "text-center lg:text-left",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                target: "_blank",
                className: "rounded-[50px] border px-4 py-1 text-white ",
                href: "#",
                children: "Try Now"
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "col-12 order-0 text-center lg:col-7 lg:order-1 lg:text-left",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
              src: data.image,
              alt: "online baking tool"
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OnlineBankingTool);
OnlineBankingTool.defaultProps = {
  className: ""
};

/***/ }),

/***/ 19367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var common_priceConvert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46518);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_IncludedFee__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68752);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35831);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var CardBankFee = function CardBankFee(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: "shadow-bbc flex h-full flex-col justify-between rounded-3xl bg-white py-10 px-7 text-center",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
      className: "mb-10 text-2xl font-semibold leading-9 text-bbc-brand-700 ",
      children: data.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("p", {
      className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().fee)),
      children: [(0,common_priceConvert__WEBPACK_IMPORTED_MODULE_0__/* .AutoConvertPriceWithUnit */ .Nd)(data.fee, 1), data.haveNote && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        children: "*"
      })]
    }), data.note && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
      className: "mt-10 grow",
      dangerouslySetInnerHTML: {
        __html: (0,common_priceConvert__WEBPACK_IMPORTED_MODULE_0__/* .convertPriceOnString */ .eY)(data.note)
      }
    })]
  });
};

var OpenBankAccount = function OpenBankAccount(_ref2) {
  var _data$bank_fee, _data$bank_fee2;

  var data = _ref2.data,
      country = _ref2.country,
      title = _ref2.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    id: "banking_options",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          className: "bbc-title mb-6 text-center capitalize",
          text: title ? title : "Open a Bank Account for ".concat(country, " Company ")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
          className: "m-auto w-5/6 text-center",
          dangerouslySetInnerHTML: {
            __html: data.note || "Note: Our banking support fee does not include the fee for bank account application or any other required fee (if any) chargeable by the bank you choose to apply."
          }
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "relative overflow-hidden pt-10 pb-10 lg:pb-20",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "container relative z-20",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "row justify-center",
          children: ((_data$bank_fee = data.bank_fee) === null || _data$bank_fee === void 0 ? void 0 : _data$bank_fee.length) > 0 && ((_data$bank_fee2 = data.bank_fee) === null || _data$bank_fee2 === void 0 ? void 0 : _data$bank_fee2.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
              className: "col-12 mt-6 first:mt-0 md:col-6 md:mt-0 lg:col-5 xl:col-4",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(CardBankFee, {
                data: item
              })
            }, index);
          }))
        })
      }), data.noteBottom && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
          className: "relative z-20 m-auto mt-6 w-5/6 text-center lg:mt-10",
          dangerouslySetInnerHTML: {
            __html: data.noteBottom || "Note: Our banking support fee does not include the fee for bank account application or any other required fee (if any) chargeable by the bank you choose to apply."
          }
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        src: "/assets/images/wave/top_bg-wave.png",
        width: 1920,
        height: 125,
        className: "w-full",
        wrapper: {
          className: "w-full absolute top-20 left-0 right-0 z-10 "
        },
        alt: "Wave top"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().waveTop))
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: "pt-10:pt-20 bg-bbc-package",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_molecules_IncludedFee__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          data: data.included
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: " absolute hidden h-1/2 w-full bg-bbc-package md:block"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        src: "/assets/images/wave/bottom-wave.png",
        width: 1920,
        height: 140,
        className: "w-full",
        wrapper: {
          className: "absolute w-full top-1/2 md:block"
        },
        alt: "Wave bottom"
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OpenBankAccount);

/***/ }),

/***/ 1059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var WalkThrough = function WalkThrough(_ref) {
  var data = _ref.data;
  var walkthrough = data.walkthrough;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      className: "bbc-title mb-6 text-center capitalize",
      text: data.title
    }), data.description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
      className: "mb-6 lg:mb-10",
      children: data.description
    }), walkthrough.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "row mb-6 justify-between last:mb-0 lg:mb-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "".concat(item.classNameLeft ? item.classNameLeft : "col-12 self-center lg:col-6"),
          children: [item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "".concat(item.classNameTitle ? "h3" : "h4"),
            className: "".concat(item.classNameTitle ? item.classNameTitle : "mb-4 text-left text-lg font-semibold lg:mb-6", "   "),
            text: item.title
          }), item.isList ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
            className: "mx-0 list-disc pl-5 text-left",
            children: item.contents.map(function (content, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
                className: "relative leading-[26px] text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: content
                }
              }, index);
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "mx-0 list-disc text-left ",
            children: item.contents.map(function (content, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
                className: "relative mb-6 list-none text-bbc-gray last:mb-0",
                dangerouslySetInnerHTML: {
                  __html: content
                }
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: (item.classNameRight ? item.classNameRight : "col-12 order-first mb-6 text-center leading-none lg:col-5 lg:mb-0 ") + (item.positionImage === "left" ? " lg:order-first" : " lg:order-last lg:text-right"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, item.img))
        })]
      }, index);
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (WalkThrough);
WalkThrough.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {})
};

/***/ }),

/***/ 53001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ open_bank_account; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/PageType/index.js
var PageType = __webpack_require__(10965);
// EXTERNAL MODULE: ./components/organisms/BankingOptions/index.js + 1 modules
var BankingOptions = __webpack_require__(25497);
// EXTERNAL MODULE: ./components/organisms/BankingOptions/bankNote.js
var bankNote = __webpack_require__(3771);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/OnlineBankingTool/index.js
var OnlineBankingTool = __webpack_require__(80651);
// EXTERNAL MODULE: ./components/organisms/OpenBankAccount/index.js
var OpenBankAccount = __webpack_require__(19367);
// EXTERNAL MODULE: ./components/organisms/RequiredDocument/index.js
var RequiredDocument = __webpack_require__(95183);
// EXTERNAL MODULE: ./components/organisms/Walkthrough/index.js
var Walkthrough = __webpack_require__(1059);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./components/templates/common/open-bank-account/banner-banking-tool/Index.module.scss
var Index_module = __webpack_require__(9176);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/common/open-bank-account/banner-banking-tool/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var BannerBankingTool = function BannerBankingTool(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          boxShadow: "0px 4px 16px rgba(37, 37, 37, 0.25)"
        },
        className: "relative flex h-auto w-full flex-col items-center overflow-hidden rounded-3xl bg-bbc-package lg:h-[414px] lg:flex-row",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-12 relative z-10 mb-4 items-center lg:col-7 lg:mb-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "pl-4 pt-9 pr-4 lg:pt-0 lg:pl-16 lg:pr-10 xl:pr-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-6 text-2xl font-semibold leading-[44px] text-white lg:mb-10 lg:text-3xl",
              dangerouslySetInnerHTML: {
                __html: data.content
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
              as: "a",
              href: "/guide-and-tool/banking-tool",
              useRouter: true,
              btnColor: "bg-white hover:bg-bbc-brand-500",
              btnTextColor: "text-bbc-brand-500 hover:text-white",
              style: {
                boxShadow: "0px 4px 16px rgba(37, 37, 37, 0.25)"
              },
              children: "TRY IT NOW"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            fontSize: "0px"
          },
          className: "col-12 relative z-10 self-end pl-4 pr-2 text-center leading-none lg:col-5 lg:px-0 lg:text-left",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, _objectSpread({}, data.image))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Index_module_default()).bgBankingTool
        })]
      })
    })
  });
};

/* harmony default export */ var banner_banking_tool = (BannerBankingTool);
;// CONCATENATED MODULE: ./components/templates/common/open-bank-account/index.js




















var NewsSlider = (0,dynamic["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8352), __webpack_require__.e(1290)]).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/common/open-bank-account/index.js -> " + "components/organisms/NewsSlider"]
  }
});

var OpenBankAccountTemplate = function OpenBankAccountTemplate(_ref) {
  var data = _ref.data,
      dataJson = _ref.dataJson,
      dataBank = _ref.dataBank;

  var _useContext = (0,react.useContext)(contexts/* LayoutContext */.VY),
      locationRouter = _useContext.locationRouter;

  var country = dataJson.country,
      hide_note = dataJson.hide_note,
      no_select = dataJson.no_select,
      dataPageType = dataJson.dataPageType,
      dataHowToOpen = dataJson.dataHowToOpen,
      dataOpenBankFee = dataJson.dataOpenBankFee;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-min-h-635",
      breadcrumbs: dataJson.breadcrumbs,
      title: "Open bank account for <br/>".concat(country, " Company"),
      titleProps: {
        className: "banner-default-title mb-10 capitalize",
        textColor: "banner-title-default-color"
      },
      dataTrustpilot: {
        dataStatic: dataJson.dataTrustpilot,
        dataDefault: data.dataTrustpilot
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: dataJson !== null && dataJson !== void 0 && dataJson.imgBanner ? dataJson === null || dataJson === void 0 ? void 0 : dataJson.imgBanner : "/assets/images/common/open-bank.png",
        className: "w-full",
        wrapper: {
          className: "bbc-banner-image-country lg:pb-0 ".concat(locationRouter === "offshore" ? "pb-[98px]" : "pb-10")
        },
        width: 591,
        height: 412,
        priority: true,
        alt: dataJson === null || dataJson === void 0 ? void 0 : dataJson.imgAlt
      }),
      bgColor: "bg-bbc-country"
    }), dataPageType && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute left-1/2 -translate-x-1/2 -translate-y-[74px] text-center lg:-translate-y-1/2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PageType/* default */.Z, {
        data: dataPageType
      })
    }), dataHowToOpen && /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "flex flex-col",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container order-2 lg:order-1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: dataHowToOpen.title,
          className: "bbc-title mt-10 mb-6 text-center capitalize lg:mt-20 lg:mb-10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "paragraph ".concat(country.toLowerCase() === "singapore" && "blue-marker"),
          children: dataHowToOpen.content.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              dangerouslySetInnerHTML: {
                __html: item
              }
            }, index);
          })
        }), dataHowToOpen.note ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: dataHowToOpen.note
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: " mt-4 border-l-4 border-bbc-brand-700 pl-2 font-medium ",
            children: ["Wonder which can be the best bank for your ", country, " company? Let's find out with our", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
              href: "/guide-and-tool/banking-tool",
              target: "_blank",
              className: "text-bbc-brand-500",
              children: "Banking Tool"
            })]
          })
        })]
      }), dataJson.dataOnlineBankingTool && typeof dataJson.dataOnlineBankingTool === "object" && Object.keys(dataJson.dataOnlineBankingTool).length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "order-1 mt-0 mb-0 lg:order-2 lg:mt-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(OnlineBankingTool/* default */.Z, {
          data: dataJson.dataOnlineBankingTool
        })
      })]
    }), dataJson.fullWalkthrough && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Walkthrough/* default */.Z, {
          data: dataJson.fullWalkthrough
        })
      })
    }), dataJson.bankingTool && /*#__PURE__*/(0,jsx_runtime.jsx)(banner_banking_tool, {
      data: dataJson.bankingTool
    }), dataOpenBankFee && Object.keys(dataOpenBankFee).length > 0 && dataOpenBankFee.bank_fee.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "pb-10 lg:pb-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OpenBankAccount/* default */.Z, {
        data: dataOpenBankFee,
        country: country,
        title: dataOpenBankFee.title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BankingOptions/* default */.Z, {
          title: "Banking Options for ".concat(country, " Company"),
          noSelect: no_select,
          dataTraditional: dataBank.traditional,
          dataEMI: dataBank.emi,
          tabArray: dataBank === null || dataBank === void 0 ? void 0 : dataBank.tabArray,
          noteTraditional: // Hide_note
          //   ? ""
          //   : "**Initial deposit is often blocked in the offshore bank account; if so, this amount is often small.<br/> However, banks in Hong Kong and Singapore do not freeze this amount, so you can use it freely. But you will be charged an additional fee for not maintaining your account above min balance.<br/>* Remote opening applies for Singapore-incorporated companies only."
          (0,bankNote/* noteTraditional */.R)(dataBank.traditional, hide_note)
        }), !hide_note && locationRouter === "offshore" && country === "BVI" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative mt-10 flex h-auto w-full flex-col items-end justify-between overflow-hidden rounded-[24px] bg-[#EFF6FF] drop-shadow-lg lg:mt-[100px] lg:min-h-[414px] lg:flex-row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:[250px] relative h-[280px]  w-full md:h-[150px]",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "absolute -left-[250px] -top-[400px] z-0 h-[800px] w-[800px] rounded-full bg-bbc-gradient-15 md:-left-[80px] md:-top-[400px] lg:-left-[120px] lg:-top-[540px] lg:bg-bbc-gradient-16"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "absolute left-0 top-0 bottom-0 w-11/12 py-8 px-4 lg:w-2/3 lg:py-20 lg:px-10 xl:py-[100px] xl:px-[65px]",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-2xl font-semibold text-bbc-white lg:text-[30px] lg:leading-[44px]",
              children: "Still unsure and need more banking options for your BVI company?"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: "mb-6 text-2xl font-semibold text-bbc-white lg:mb-10 lg:text-[30px] lg:leading-[44px]",
              children: ["Find out with our", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: " text-bbc-brand-700",
                children: "Banking Tool"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "pt-2",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                as: "a",
                target: "_blank",
                rel: "noopener noreferrer",
                href: "/offshore/guide-and-tool/banking-tool",
                className: "rounded-full bg-bbc-white px-6 py-2 font-semibold uppercase text-bbc-primary drop-shadow-xl hover:text-bbc-brand-700",
                children: "Try it now"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "bottom-0 z-10 flex lg:absolute lg:right-6 xl:right-[65px]",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/offshore/banking-support/trynow-bvi-banking.png",
              alt: "placeholder",
              width: 398,
              height: 384
            })
          })]
        }), !hide_note && locationRouter === "offshore" && country !== "BVI" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-10 text-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6",
            children: "Need more references? Here is a Banking Tool to make your decision easier!"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
            as: "a",
            target: "_blank",
            rel: "noopener noreferrer",
            href: "/offshore/guide-and-tool/banking-tool",
            children: "Try Now"
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RequiredDocument/* default */.Z, {
        title: dataJson.dataRequiredDocument.title || "Required Documents",
        data: dataJson.dataRequiredDocument,
        sectionClassName: "py-10 lg:py-20",
        backgroundImage: "/assets/images/common/required-documents.png"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var open_bank_account = (OpenBankAccountTemplate);
OpenBankAccountTemplate.defaultProps = {
  data: {},
  posts: []
};

/***/ }),

/***/ 35831:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fee":"Index_fee__whWDJ","waveTop":"Index_waveTop__6hRwa"};

/***/ }),

/***/ 9176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgBankingTool":"Index_bgBankingTool__zjKob"};

/***/ })

}]);